import {
  space,
  SpaceProps,
  width,
  WidthProps,
  compose,
  fontSize,
  fontWeight,
  FontWeightProps,
  FontSizeProps,
  FontFamilyProps,
  fontFamily,
} from 'styled-system';
import { css, Theme } from '@emotion/react';
import styled from 'components/styled';

type Props = {
  text?: string;
  theme?: Theme;
} & WidthProps &
  SpaceProps &
  FontWeightProps &
  FontSizeProps &
  FontFamilyProps;

export const Divider = styled.hr<Props>`
  ${({ theme, text = '' }) => css`
    line-height: ${theme.fontSizes.s};
    position: relative;
    outline: 0;
    border: 0;
    color: ${theme.colors.mediumGrey};
    text-align: center;
    height: ${theme.fontSizes.s};
    margin-bottom: 0;
    margin-top: 0;
    &:before {
      content: '';
      background-color: ${theme.colors.mediumGrey};
      border: 0;
      position: absolute;
      left: 0;
      top: 50%;
      width: 100%;
      height: 1px;
    }
    &:after {
      content: '${text.replace("'", "\\'")}';
      position: relative;
      display: inline-block;
      padding: 0 1em;
      line-height: ${theme.fontSizes.s};
      color: ${theme.colors.darkGrey};
      background-color: white;
    }
  `}

  ${compose(space, width, fontWeight, fontSize, fontFamily)}
`;

export default Divider;
